// src/App.js
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AppWrapper from "./AppWrapper";
import { ThemeProvider } from "./theme/ThemeProvider";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppWrapper />
        <ToastContainer position="top-center" />
      </Router>
    </ThemeProvider>
  );
}

export default App;